module.exports = __webpack_public_path__ + "as.e0de4550.svg";